export const modalMessagesStep2 = {
    RUBRO_PROHIBIDO_1_1_TITLE: 'Lo sentimos, en este momento, el rubro que seleccionaste no puede realizar el proceso de contratación a través del sitio web.',
    RUBRO_PROHIBIDO_1_1_DESCRIPTION: 'Llama al Contact center al <strong>600 638 6380</strong> o al <strong>+56 2 2661 2700</strong> dónde uno de nuestros ejecutivos te ayudará a contratar el producto o servicio que necesitas.',
    RUBRO_PROHIBIDO_1_1_BUTTON: 'Entendido',

    RUBRO_PROHIBIDO_N_N_TITLE: 'Lo sentimos, en este momento, el rubro que seleccionaste no puede realizar el proceso de contratación a través del sitio web.',
    RUBRO_PROHIBIDO_N_N_DESCRIPTION: 'Puedes continuar con tu proceso de contratación, seleccionando otra categoría o rubro de tu lista',
    RUBRO_PROHIBIDO_N_N_BUTTON: 'Entendido',

    PRODUCTO_PROHIBIDO_TITLE: 'Producto no disponible',
    PRODUCTO_PROHIBIDO_BUTTON: 'Entendido',

    PRODUCTO_MAXIMO_TITLE: 'Cantidad máxima de productos',
    PRODUCTO_MAXIMO_DESCRIPTION: 'Por el tipo de tu comercio sólo puedes solicitar hasta un máximo de 3 unidades por producto. Hemos actualizado tu carrito de compras con esta cantidad.',
    PRODUCTO_MAXIMO_BUTTON: 'Entendido',

    ACTIVIDAD_NO_CATEGORIA_TITLE: 'Lo sentimos, en este momento, el rubro que seleccionaste no puede realizar el proceso de contratación a través del sitio web',
    ACTIVIDAD_NO_CATEGORIA_DESCRIPTION: 'Puedes continuar con tu proceso de contratación, seleccionando otra categoria o rubro de tu lista.',
    ACTIVIDAD_NO_CATEGORIA_BUTTON: 'Entendido',

    PROCESO_SEGUNDO_PLANO_TITLE: 'Procesando información',
    PROCESO_SEGUNDO_PLANO_DESCRIPTION: 'No cierres la página hasta finalizar el proceso,<br> esto puede tomar unos segundos. <br> Por favor espera.',
    PROCESO_SEGUNDO_PLANO_BUTTON: 'Ir a Portal Público',

    ACTIVIDAD_SIN_RUBRO_TITLE: 'Lo sentimos, en este momento, la actividad que seleccionaste no puede realizar el proceso de contratación a través del sitio web',
    ACTIVIDAD_SIN_RUBRO_DESCRIPTION: 'Llama al Contact center al <strong>600 638 6380</strong> o al <strong>+56 2 2661 2700</strong> dónde uno de nuestros ejecutivos te ayudará a contratar el producto o servicio que necesitas.',
    ACTIVIDAD_SIN_RUBRO_BUTTON: 'Salir',

    TRES_SOCIOS_FIRMA_CONJUNTA: 'Lo sentimos, el RUT ingresado no puede realizar el proceso de contratación a través del sitio web.',
    TRES_SOCIOS_FIRMA_DESCRIPTION: 'Por favor, llama al <strong>Contact center al 600 638 6380 o al <strong>+56 2 2661 2700</strong> dónde uno de nuestros ejecutivos te ayudará a contratar el producto o servicio que necesitas.',
    TRES_SOCIOS_FIRMA_BUTTON: 'Cerrar'
};
